import React, { useContext, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Image from "react-bootstrap/esm/Image";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { default as config } from "../config.json";
import "../ProductsListForCustomer.css";
import { Store } from "../Store";
import { turkishCurrencyFormatterNoPrecision } from "../utils";
import SepeteEkle from "./SepeteEkle";

export default function ProductsListForCustomer(props) {
  const {
    products,
    tableNum,
    feature,
    setFeature,
    product,
    setProduct,
    features,
    setFeatures,
  } = props;

  const { dispatch: ctxDispatch } = useContext(Store);
  const [productQuantity, setProductQuantity] = useState(1);

  const decrementProductItemHandler = (quantity) => {
    if (
      (product.isHalfPortion && productQuantity > 0.5) ||
      (!product.isHalfPortion && productQuantity > 1)
    ) {
      if (productQuantity - (quantity ? quantity : 1) > 0) {
        setProductQuantity(productQuantity - (quantity ? quantity : 1));
      }
    }
  };

  const incrementProductItemHandler = (quantity) => {
    if (
      product.questions?.length > 0 &&
      productQuantity + (quantity || 1) > 1
    ) {
      toast.info(
        "Bu ürün menü olarak tanımlanmış, menü ürünleri sepete bir adet veya yarım porsiyon olarak eklenmelidir!",
        { autoClose: 10000 }
      );
      return;
    }

    setProductQuantity(productQuantity + (quantity ? quantity : 1));
  };

  const updateCartHandler = (quantity, questions) => {
    if (features && features.length === 1) {
      ctxDispatch({
        type: "CART_ADD_ITEM",
        payload: {
          ...product,
          quantity,
          createdAt: new Date().toISOString(),
          feature: product.features[0],
          tableNum: tableNum,
          itemCode: uuidv4(),
          questions,
          answers: questions
            .filter((q) => q.answers.filter((a) => a.selected).length > 0)
            .map((q) => ({
              question: q.question,
              questionId: q._id,
              answers: q.answers
                .filter((a) => a.selected)
                .map((a) => ({
                  answer: a.answer,
                  answerId: a._id,
                  cost: a.cost,
                  image: a.image,
                  product: a.product,
                  feature: a.feature,
                  firstCost: a.firstCost,
                })),
            })),
        },
      });
    } else {
      ctxDispatch({
        type: "CART_ADD_ITEM",
        payload: {
          ...product,
          quantity,
          createdAt: new Date().toISOString(),
          feature: feature,
          tableNum: tableNum,
          itemCode: uuidv4(),
          stockOutputs: [],
          features: [],
          questions,
          answers: questions
            .filter((q) => q.answers.filter((a) => a.selected).length > 0)
            .map((q) => ({
              question: q.question,
              questionId: q._id,
              answers: q.answers
                .filter((a) => a.selected)
                .map((a) => ({
                  answer: a.answer,
                  answerId: a._id,
                  cost: a.cost,
                  image: a.image,
                  product: a.product,
                  feature: a.feature,
                  firstCost: a.firstCost,
                })),
            })),
        },
      });
    }

    toast.success(
      quantity +
        " adet " +
        (feature ? feature.name + " " : "") +
        product.name +
        " sepete eklendi"
    );
  };

  return (
    <div>
      <div>
        {features && features.length > 0 && !feature ? (
          <div>
            {features.map((f) => {
              return (
                <div
                  className="product-card"
                  key={f._id}
                  onClick={() => {
                    setFeature(f);
                  }}
                >
                  <h5>
                    {f.name.startsWith("Normal")
                      ? product.name
                      : f.name + " " + product.name}
                  </h5>
                  <span>
                    {turkishCurrencyFormatterNoPrecision(
                      product.price + f.price
                    )}
                  </span>
                </div>
              );
            })}
            <div className="product-card">
              <Button
                variant="danger"
                className="return-button"
                onClick={() => {
                  setProduct("");
                  setFeature("");
                  setFeatures([]);
                }}
              >
                <i className="fas fa-arrow-left"></i>&nbsp;
                {"Çık"}
              </Button>
            </div>
          </div>
        ) : (product && product.features.length === 0) ||
          (product && feature) ? (
          <SepeteEkle
            setFeatures={setFeatures}
            setProduct={setProduct}
            product={product}
            feature={feature}
            decrementProductItemHandler={decrementProductItemHandler}
            productQuantity={productQuantity}
            incrementProductItemHandler={incrementProductItemHandler}
            setFeature={setFeature}
            setProductQuantity={setProductQuantity}
            updateCartHandler={updateCartHandler}
          ></SepeteEkle>
        ) : (
          products.map((p) => {
            return (
              <div className="product-grid" key={p._id}>
                <div
                  className="product-card"
                  key={p._id}
                  onClick={() => {
                    //setFeatures(p.features);
                    //setProduct(p);
                  }}
                >
                  <Image
                    className="product-image"
                    src={p.image || config.default_image}
                    alt={p.name}
                    fluid
                    rounded
                  ></Image>
                  <div className="product-info">
                    <span className="product-name">{p.name}</span>
                    <span className="product-price">
                      {turkishCurrencyFormatterNoPrecision(p.price)}
                    </span>
                    {p.description && p.description !== p.name && (
                      <span className="product-description">
                        {p.description}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
